import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { trackDocumentLang } from "./i18n";
import { register } from "./lib/offline";
import "./index.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root is missing from index.html");
}

trackDocumentLang();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Offline support is a progressive enhancement: a failure here (unsupported
// browser, storage denied) must never take the rendered app down with it.
try {
  void register().catch(() => {});
} catch {
  // register() never throws synchronously, but nothing here may ever bubble up.
}
